import type { ConditionType, HeliosNotificationConditionsBaseState, HeliosNotificationConditionsState } from '..';

export const dynamicallyUpdateBase = (
  state: HeliosNotificationConditionsState,
  {
    payload,
  }: {
    payload: {
      type: ConditionType;
      key: keyof HeliosNotificationConditionsBaseState;
      value: HeliosNotificationConditionsBaseState[keyof HeliosNotificationConditionsBaseState];
    };
  }
) => {
  state[payload.type] = {
    ...state[payload.type],
    [payload.key]: payload.value,
  } as HeliosNotificationConditionsBaseState;
};
